/**
 * tdesign v1.0.6
 * (c) 2023 TDesign Group
 * @license MIT
 */

var CheckboxProps = {
  block: {
    type: Boolean,
    default: true
  },
  checkAll: Boolean,
  checked: {
    type: Boolean,
    default: void 0
  },
  modelValue: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  content: {
    type: [String, Function]
  },
  contentDisabled: Boolean,
  default: {
    type: [String, Function]
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  icon: {
    type: [String, Boolean, Array],
    default: "circle"
  },
  indeterminate: Boolean,
  label: {
    type: [String, Function]
  },
  maxContentRow: {
    type: Number,
    default: 5
  },
  maxLabelRow: {
    type: Number,
    default: 3
  },
  name: {
    type: String,
    default: ""
  },
  placement: {
    type: String,
    default: "left",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "right"].includes(val);
    }
  },
  readonly: Boolean,
  value: {
    type: [String, Number, Boolean]
  },
  onChange: Function
};

export { CheckboxProps as default };
//# sourceMappingURL=props.js.map
